import { ProductDesign } from '@inter-ikea-storageone/range';
import { equals } from 'ramda';
export var AutoFillDoorTypeEnum;
(function (AutoFillDoorTypeEnum) {
    AutoFillDoorTypeEnum["HINGED"] = "HINGED";
    AutoFillDoorTypeEnum["NONE"] = "NONE";
    AutoFillDoorTypeEnum["SLIDING"] = "SLIDING";
})(AutoFillDoorTypeEnum || (AutoFillDoorTypeEnum = {}));
/**
 * Represents a single wall component with autofill properties.
 */
class AutofillSingleWallComponent {
    /**
     * Creates an instance of AutofillSingleWallComponent.
     * @param wallWidth - The width of the wall.
     * @param doorType - The type of door.
     * @param cameraDirection - The direction of the camera.
     * @param design - The design of the product.
     * @param frameHeight - The height of the frame.
     * @param frameDepth - The depth of the frame.
     * @param finished - Callback function to be called when finished.
     */
    constructor(wallWidth, doorType, cameraDirection, design, frameHeight, frameDepth, finished) {
        this.typeId = AutofillSingleWallComponent.id;
        this.doStoreInSnapshot = false;
        this.serializable = false;
        this.wallWidth = 0;
        this.doorType = AutoFillDoorTypeEnum.HINGED;
        this.design = ProductDesign.WHITE;
        this.frameHeight = 0;
        this.frameDepth = 0;
        this.wallWidth = wallWidth;
        this.doorType = doorType;
        this.cameraDirection = cameraDirection;
        this.design = design;
        this.frameHeight = frameHeight;
        this.frameDepth = frameDepth;
        this.finished = finished;
    }
    /**
     * Checks if this component is equal to another AutofillSingleWallComponent.
     * @param other - The other component to compare with.
     * @returns True if the components are equal, false otherwise.
     */
    eq(other) {
        return (this.wallWidth === other.wallWidth &&
            this.doorType === other.doorType &&
            equals(this.cameraDirection, other.cameraDirection) &&
            this.design === other.design &&
            this.frameHeight === other.frameHeight &&
            this.frameDepth === other.frameDepth);
    }
}
AutofillSingleWallComponent.id = 2089;
export default AutofillSingleWallComponent;
//# sourceMappingURL=AutofillSingleWallComponent.js.map